import { InspectCodeItems } from "../../utils/InspectCodeItems";

export const ResultsPercentages = ({ results }) => {
    const count = results.successCount + results.warningCount + results.errorCount;
    const successPercent = count > 0 ? Math.round(results.successCount / count * 100) : 0;
    const warningPercent = count > 0 ? Math.round(results.warningCount / count * 100) : 0;
    const errorsPercent = count > 0 ? Math.round(results.errorCount / count * 100) : 0;
    const totalPercent = successPercent + warningPercent + errorsPercent;

    return (
        <div className="flex w-full" style={{height: 16}}>
            <div style={{color: "palegreen", backgroundColor: "limegreen", width: successPercent + '%'}}><p style={{marginTop: -4}}>{successPercent}%</p></div>
            <div style={{color: "cornsilk", backgroundColor: "gold", width: warningPercent + '%'}}><p style={{marginTop: -4}}>{warningPercent}%</p></div>
            <div style={{color: "orange", backgroundColor: "red", width: errorsPercent + '%'}}><p style={{marginTop: -4}}>{errorsPercent}%</p></div>
            {totalPercent < 100 && <div style={{backgroundColor: "darkgray", width: (100 - totalPercent) + '%'}}>&nbsp;</div>}
        </div>
    );
}
